import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { BeketTicket } from 'shared/api/beket/search'
import { prepareDuration } from 'shared/lib/prepareDuration.ts'
import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
// import { MBonusBeket } from 'shared/ui/beket/mbonus-beket'
import { ResultCardDetails } from 'shared/ui/result-card-details'
import { ResultCardDetail } from 'shared/ui/result-card-details/model.ts'

import s from './styles.module.scss'

interface Props {
  routeData: ResultCardDetail | null
  ticket: BeketTicket
  onClick?: () => void
}

export const BeketResultsCard = ({ routeData, ticket, onClick }: Props) => {
  const { t } = useTranslation()

  const timeDuration = prepareDuration(ticket?.duration)

  const timeDurationText = t('time_flight', {
    hours: timeDuration?.hours,
    minutes: timeDuration?.minutes,
  })

  return (
    <div
      className={s.card}
      onClick={onClick}
    >
      <div className={s.cardHeader}>
        <div className={s.headerWrapper}>
          <div className={s.headerText}>
            <p className="extra-bold-20">{priceShow(ticket?.price)} &#8384;</p>
            <p className={clsx('regular-14', s.timeInRide)}>
              {timeDurationText}
            </p>
          </div>
        </div>
        {/* {ticket.mbonus && <MBonusBeket text={ticket.mbonus.percentage} />} */}
      </div>

      {routeData && <ResultCardDetails item={routeData} />}

      <div className={s.bottom}>
        <p className={clsx('regular-12', s.typeTransport)}>
          <AppIcon
            id={AllIcons.BUS}
            width={16}
            height={16}
          />

          {ticket?.transport?.transport_model || ''}
        </p>
      </div>
    </div>
  )
}
